import React, { useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

const MultipleCharts = ({ data, price }) => {
    const chartRef = useRef(null);
    const [chartType, setChartType] = useState(1);

    const xAxisData = data.map(item => item.time); // Extracting times
    let seriesData = null;
    if (chartType === 2) {
        seriesData = data.map(item => item.price);
    } else {
        seriesData = data.map(item => [
            item.open, item.close, item.low, item.high
        ]);
    }

    const handleChartClick = (params) => {
        if (params.componentType === 'graphic' && params.event.target.style.image !== undefined) {
            console.log('Current chart type:', chartType);

            setChartType(prevChartType => {
                const newChartType = prevChartType === 1 ? 2 : 1;
                return newChartType; // Return the new state
            });
        }
    };

    // Inside useEffect
    useEffect(() => {
        const chart = chartRef.current.getEchartsInstance();
        chart.on('click', handleChartClick);

        return () => {
            chart.off('click', handleChartClick);
        };
    }, []);

    const candleStickOptions = {
        backgroundColor: 'transparent',
        title: null,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                lineStyle: {
                    color: '#999'
                },
                crossStyle: {
                    color: '#999'
                }
            }
        },
        grid: {
            left: '2%',
            right: '5%',
            bottom: '2%',
            top: '5%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: xAxisData,
            boundaryGap: true,
            axisLine: {
                onZero: false,
                lineStyle: {
                    color: '#ffffff4d',
                },
            },
            splitLine: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            scale: true,
            axisLabel: {
                formatter: '{value}',
                fontSize: 10,
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#ffffff1a',
                },
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ffffff4d',
                },
            },
        },
        series: [{
            name: 'Trading Info',
            type: 'candlestick',
            data: seriesData,
            itemStyle: {
                color: '#06B800',
                color0: '#F00',
                borderColor: '#06B800',
                borderColor0: '#F00'
            }
        }],
        graphic: [
            {
                type: 'image',
                right: 10,
                top: 7,
                style: {
                    image: require('../media/icons/reload_icon.png'),
                    width: 15,
                    height: 15
                }
            },
            {
                type: 'text',
                right: 40,
                top: 10,
                style: {
                    text: `Price: ₹${price}`,
                    fill: '#fff',
                    font: '12px Arial',
                    textAlign: 'left'  // Align text to the left
                }
            }
        ]
    };

    const areaChartOption = {
        backgroundColor: 'transparent',
        title: null,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                lineStyle: {
                    color: '#999'
                },
                crossStyle: {
                    color: '#999'
                }
            }
        },
        grid: {
            left: '2%',
            right: '5%',
            bottom: '2%',
            top: '5%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: xAxisData,
            boundaryGap: true,
            axisLine: {
                onZero: false,
                lineStyle: {
                    color: '#ffffff4d',
                },
            },
            splitLine: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            scale: true,
            axisLabel: {
                formatter: '{value}',
                fontSize: 10,
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#ffffff1a',
                },
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ffffff4d',
                },
            },
        },
        series: [{
            name: 'Area Graph Data',
            type: 'line',
            data: seriesData,
            areaStyle: {
                color: 'rgba(0, 119, 255, 0.3)', // Adding a semi-transparent area fill
            },
            itemStyle: {
                color: '#0077ff', // Line color
            },
            smooth: true, // Smooths the line for a cleaner look
        }],
        graphic: [
            {
                type: 'image',
                right: 10,
                top: 7,
                style: {
                    image: require('../media/icons/reload_icon.png'),
                    width: 15,
                    height: 15
                }
            },
            {
                type: 'text',
                right: 40,
                top: 10,
                style: {
                    text: `Price: ₹${price}`,
                    fill: '#fff',
                    font: '12px Arial',
                    textAlign: 'left'  // Align text to the left
                }
            }
        ]
    };

    const currentOption = chartType === 1 ? candleStickOptions : areaChartOption;

    return (
        <ReactECharts
            ref={chartRef}
            option={currentOption}
            style={{ height: '100%', width: '100%' }}
        />
    );
};

export default MultipleCharts;